import { useContext } from 'react';
import { AppContext, EMPTY_OBJECT, UserContext } from 'commons-ui';

import useService from '../utils/useService';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT, setConfirmationDialog } = params;
	const { app, showAlert } = useContext(AppContext);
	const { user } = useContext(UserContext);
	const { toggleIsActiveField } = useService();

	switch (action.id) {
		case 'edit':
			return () => {
				history.push({
					pathname: '/dashboard/banner/edit',
					state: {
						rowData
					}
				});
			};
		case 'clone':
			return () => {
				history.push({
					pathname: '/dashboard/banner/clone',
					state: {
						rowData
					}
				});
			};
		case 'add':
			return () => {
				history.push({
					pathname: '/dashboard/banner/create'
				});
			};
		case 'deploy': {
			const toggleIsActive = () => {
				return toggleIsActiveField(rowData, history, user, app, showAlert);
			};

			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Deploy on app?',
					handleAlertConfirmation: toggleIsActive
				});
			};
		}

		case 'remove': {
			const toggleIsActive = () => {
				return toggleIsActiveField(rowData, history, user, app, showAlert);
			};

			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Remove from app?',
					handleAlertConfirmation: toggleIsActive
				});
			};
		}
		case 'versionHistory':
			return () => {
				history.push({
					pathname: '/dashboard/banner/versionHistory',
					state: {
						rowData
					}
				});
			};
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
